import { Injectable, inject } from '@angular/core';
import {AbstractControl, ValidatorFn, Validators} from '@angular/forms';
import {FieldParamValue as FieldParamValueInterface} from '../../../interface/api/FieldParamValue';
import {FieldParam as FieldParamInteface} from '../../../interface/api/FieldParam';
import {Field as FieldInterface} from '../../../interface/api/Field';
import {ToolsService} from '../../../shared/services/tools/tools.service';
import {TranslationService} from '../../../shared/services/translation.service';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {FieldValue, FieldValueInterface} from '../../../class/api/FieldValue';
import {FieldValueManagerService} from '../formulaire-saisie/field-value-manager.service';
import {FieldParamValue} from '../../../class/api/FieldParamValue';
import {ActivatedRoute, Router} from '@angular/router';
import {Laboratoire} from '../../../interface/api/Laboratoire';

@Injectable()
export class GenerateFormControlService {
    private fieldValueManager = inject(FieldValueManagerService);
    private toolService = inject(ToolsService);
    translationService = inject(TranslationService);
    private authService = inject(AuthentificationService);
    private router = inject(Router);


    createValidorsFromField(field: FieldInterface): ValidatorFn[] {
        const validators = [];
        if (field.obligatoire) {validators.push(Validators.required);}
        field.paramValues.map((paramValue: FieldParamValueInterface) => {
            //Si j'ai une valeur custom on regarde a quel control il faut la rattacher
            if (paramValue.value != null && paramValue.value != '') {
                const fieldParam = paramValue.fieldParam as FieldParamInteface;

                if (fieldParam.code.indexOf('charMax') != -1) {
                    const charMax = Validators.maxLength(+paramValue.value);
                    validators.push(charMax);
                }
                if (fieldParam.code.indexOf('charMin') != -1) {
                    const charMax = Validators.minLength(+paramValue.value);
                    validators.push(charMax);
                }

            }
        });
        return validators;
    }

    getDateLimit(field: FieldInterface, limit: string = 'date_dateMin') {
        let date = this.getValueFromCode(field, limit) as any;
        if (date && date != null) {
            date = this.toolService.convertDateForFront(date);
        } else {
            //renvoie false en cas de problème ce qui permet de tester la valeur de retour dans une conditions
            date = false;
        }

        return date;
    }

    // Fonction pour les selects à choix unique ou multiple
    public getFieldByCodeFromFields(
        code: string,
        fields: FieldInterface[] = []
    ) {
        return fields.filter(item => item.code === code)[0];
    }

    /**
     * @deprecated fonction mal nommée, utiliser getValueFromCode
     */
    public getparamValueFromCode(field: FieldInterface, code: string) {
        return this.getValueFromCode(field, code);
    }

    public getValueFromCode(field: FieldInterface, code: string) {
        let value = null;
        field.paramValues.map((paramValue: FieldParamValueInterface) => {
            if (paramValue.value != null && paramValue.value != '') {
                const fieldParam = paramValue.fieldParam as FieldParamInteface;
                if (fieldParam.code === code) {
                    value = paramValue.value;
                }
            }
        });
        return value;
    }

    public getValueFromCodeIndexOf(field: FieldInterface, code: string): string | null {
        let value = null;
        field.paramValues.map((paramValue: FieldParamValueInterface) => {
            if (paramValue.value != null && paramValue.value != '') {
                const fieldParam = paramValue.fieldParam as FieldParamInteface;
                if (fieldParam.code.indexOf(code) != -1) {
                    value = paramValue.value;
                }
            }
        });
        return value;
    }

    public getOrCreateParam(
        field: FieldInterface,
        code: string,
        defaultValue: string
    ){
        const existingValue = this.getParamFromCode(field, code);
        if(existingValue){
            return existingValue;
        }

        const syntheticValue =  new FieldParamValue(
            {
                fieldParam: '/api/field_params/' + code,
                value: defaultValue,
            }
        );

        field.paramValues.push(syntheticValue);

        return syntheticValue;
    }

    public getParamFromCode(
        field: FieldInterface,
        code: string
    ): FieldParamValue | null {
        let value = null;
        field.paramValues.map((paramValue: FieldParamValueInterface) => {
            const fieldParam = paramValue.fieldParam as FieldParamInteface;
            if (fieldParam && fieldParam.code && fieldParam.code == code) {
                value = paramValue;
            }
        });
        return value;
    }

    public getParamFromCodeIndexOf(
        field: FieldInterface,
        code: string
    ): FieldParamValue | null {
        let value = null;
        field.paramValues.map((paramValue: FieldParamValueInterface) => {
            const fieldParam = paramValue.fieldParam as FieldParamInteface;
            if (
                fieldParam &&
                fieldParam.code &&
                fieldParam.code.indexOf(code) != -1
            ) {
                value = paramValue;
            }
        });
        return value;
    }

    public getLabelForDynamicObject(item: any) {
        //si c'est un string exemple pour les tableau de données statique non traduite
        if (typeof item === 'string') {
            return item;
        } else if (typeof item === 'object') {
            if (
                item['translations'] != undefined &&
                item['translations'] != null
            ) {
                return (this.translationService.getTranslation(item)?.label) ?? '';
            }
            if (item['label'] != undefined && item['label'] != null) {
                return item['label'];
            }
            if (item['titre'] != undefined && item['titre'] != null) {
                return item['titre'];
            }
        }
        return '';
    }

    public setValueForSelection(item: any) {
        if (typeof item != 'object') {
            return item;
        } else if (typeof item === 'object') {
            if (item['id'] != undefined && item['id'] != null) {
                return item['id'];
            } else if (item['code'] != undefined && item['code'] != null) {
                return item['code'];
            } else if (item['value'] != undefined && item['value'] != null) {
                return item['value'];
            }
        }
        return '';
    }

    hasControlField(
        abstractControl: AbstractControl,
        itemControl: string
    ): boolean {
        if (abstractControl.validator) {
            const validator = abstractControl.validator({} as AbstractControl);
            if (validator && validator['itemControl']) {
                return true;
            }
        }
        if (abstractControl['controls']) {
            for (const controlName in abstractControl['controls']) {
                if (abstractControl['controls'][controlName]) {
                    if (
                        this.hasControlField(
                            abstractControl['controls'][controlName],
                            itemControl
                        )
                    ) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    hasRequiredField(abstractControl: AbstractControl): boolean {
        if (abstractControl.validator) {
            const validator = abstractControl.validator({} as AbstractControl);
            if (validator && validator.required) {
                return true;
            }
        }
        if (abstractControl['controls']) {
            for (const controlName in abstractControl['controls']) {
                if (abstractControl['controls'][controlName]) {
                    if (
                        this.hasRequiredField(
                            abstractControl['controls'][controlName]
                        )
                    ) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    /**
     * Traverses a router tree from root to a leaf looking for {@param}.
     */
    getParam(param: string): string | null {
        for (const route of this.getCurrentRoutesChain()) {
            if (route.snapshot.paramMap.has(param)) {
                return route.snapshot.paramMap.get(param);
            }
        }
        return null;
    }

    /**
     * Retrieves a chain of {ActivatedRoutes} from root to a leaf.
     */
    getCurrentRoutesChain(): ActivatedRoute[] {
        let currentRoute = this.router.routerState.root;
        const results: ActivatedRoute[] = [currentRoute];

        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
            results.push(currentRoute);
        }

        return results;
    }

    public buildFieldValueWithDefaultValue(
        _field: FieldInterface,
        _fieldValue: FieldValueInterface | null = null,
        _fieldKey: string = 'fieldArray'
    ) {
        //Si il y a déjà une valeur enregistré, on ne fait rien
        if (_fieldValue && _fieldValue.value && _fieldValue.value !== '') {
            return _fieldValue;
        }

        //Sinon, on va chercher la valeur par defaut.
        const field = {..._field};
            let fieldValue = {..._fieldValue};
        if (_fieldValue == null) {
            fieldValue = new FieldValue({field: field['@id'], value: ''});
            delete fieldValue.formulaireSaisie;
        }

        if (_fieldKey == 'fieldArray') {
            // On regarde si il y a une valeur par default :
            const defaultValue = this.getValueFromCodeIndexOf(
                field,
                'defaultValue'
            );

            if (defaultValue == null || defaultValue == '') {
                return fieldValue;
            }

            let value = null;
            // Pas d'auto completion mais valeur fournie :
            if (defaultValue.indexOf('%') == -1) {
                value = defaultValue;
            } else {
                // Clé d'auto complétion fournie :
                value = this.getDefaultValueFromCode(defaultValue);
            }

            if (value != null && value != '') {
                fieldValue.value = value;

                // hack : on ne push pas dans le store une valeur invalide
                if (typeof value !== 'object') {
                    this.fieldValueManager.setField(
                        field.id,
                        fieldValue as FieldValue,
                        _fieldKey
                    );
                }
            }

        }

        return fieldValue;

    }

    private getDefaultValueFromCode(defaultValue: any) {

        // impersonated by an admin
        /*    if (this.getParam("switch_user")) {
                return null;
            }*/

        switch (
            defaultValue // Switch manuel pour plus de control sur les champs implémenté
            ) {
            case '%profil.civilite%':
                //TODO remplacer ça par une API et ID pour gerer les civilites
                //Actuellement : M / F
                return this.authService.userConnected.civilite.toLowerCase();

            case '%profil.nom%':
                return this.authService.userConnected.nom;

            case '%profil.prenom%':
                return this.authService.userConnected.prenom;

            case '%profil.nomNaissance%':
                return this.authService.userConnected.nomNaissance;

            case '%profil.dateNaissance%':
                return this.toolService.convertDateForFront(
                    this.authService.userConnected.dateNaissance
                );

            case '%profil.email%':
                return this.authService.userConnected.email;

            case '%profil.emailPro%':
                return this.authService.userConnected.emailPro;

            case '%profil.numORCID%':
                return this.authService.userConnected.numORCID;

            case '%profil.telPro%':
                return this.authService.userConnected.telPro;

            case '%profil.nationalites[0].id%':
                return this.authService.userConnected.nationalites[0]['code'];

            case '%profil.nationalites[1].id%':
                if (
                    this.authService.userConnected
                        .nationalites.length > 1
                ) {
                    return this.authService.userConnected
                        .nationalites[1]['code'];
                }
                return null;

            case '%profil.cvCourt%':
                return this.authService.userConnected.cvCourt;

            case '%profil.affiliation%':
                return GenerateFormControlService.extractIRI(
                    this.authService.userConnected.affiliation
                );

            case '%profil.autreAffiliation%':
                return this.authService.userConnected.affiliationOther;

            case '%profil.statut%':
                return GenerateFormControlService.extractIRI(
                    this.authService.userConnected.statutChercheur
                );

            case '%profil.autreStatut%':
                return this.authService.userConnected.statutChercheurOther;

            case '%clone:profil.adresse%':
                // hack, la persistence de l'adresse est déportée dans le composant
                // ATTENTION : la field value est temporairement invalide
                if (
                    this.authService.userConnected.adresse
                ) {
                    return {
                        ...(this.authService.userConnected.adresse as Object),
                    } as Object;
                }
                break;

            default:
                console.log(
                    '%c Autocomplétion non développée [ ' +
                    defaultValue +
                    ' ] ',
                    'background : red; color : #fff'
                );
                break;
        }

    }

    public getLaboFromProfilWithCondition(restricCountry = false): boolean | Laboratoire {
        let data: boolean | Laboratoire = false;
        if (this.authService.userConnected.laboratoire != '' && this.authService.userConnected.laboratoire != null) {
            if (typeof this.authService.userConnected.laboratoire === 'object') {
                if (!restricCountry) {
                    data = this.authService.userConnected.laboratoire;
                } else {
                    const laboCountry = this.authService.userConnected.laboratoire['adresse']['pays'];
                    if (typeof laboCountry === 'string' && laboCountry === '/api/countries/FR') {
                        data = this.authService.userConnected.laboratoire;
                    } else {
                        if (typeof laboCountry === 'object' && laboCountry['@id'] === '/api/countries/FR') {
                            data = this.authService.userConnected.laboratoire;
                        }
                    }
                }
            } else {
                data = false;
            }
        } else {
            data = false;
        }
        return data;
    }

    private static extractIRI(value: any) {
        if (value && typeof value === 'object') {
            return value['id'];
        }
        return value;
    }
}
